import dayjs from 'dayjs'

export const getReportDueDate = (value, today = dayjs()) => {
  const date = value ? dayjs(String(value).slice(0, 10)) : null
  if (!date?.isValid()) return { vencimiento: '', dias: '' }
  const days = date.startOf('day').diff(dayjs(today).startOf('day'), 'day')
  return { vencimiento: days >= 0 ? 'Por vencer' : 'Vencido', dias: Math.abs(days) }
}
